/** @format */

export default {
  data() {
    return {
      blockHeight: 256,
      detailHeight: 300,
      contentHeight: 0,
      blockName: '',
    };
  },
  updated() {
    // console.log('updated autoHeightBlock');
    this.autoHeightBlock();
    this.$nextTick(() => {
      this.autoHeightDetail();
    });
  },
  watch: {
    contentHeight(v) {
      this.autoHeightDetail(v);
    },
    typeShow(v) {
      if (v == 'dialog') {
        this.contentHeight += 180;
      }
    },
  },
  computed: {
    isInDialog() {
      return this.typeShow == 'dialog';
    },
    styleDetailCard() {
      return `height: ${this.detailHeight}px; overflow: auto`;
    },
  },
  methods: {
    setContentHeight(e) {
      console.log('setContentHeight', e);
      this.contentHeight = e;
    },
    autoHeightBlock() {
      if (this.$vuetify.breakpoint.name == 'xs') {
        this.blockHeight = 330;
        return;
      }
      let block = document.querySelector((this.blockName ? `.${this.blockName} ` : '') + '.block_master');
      if (block && block.clientHeight) this.blockHeight = block.clientHeight;
      //if (this.blockHeight < 330) this.blockHeight = 330;
    },
    getHeightBlock(n) {
      let h = this.blockHeight;
      if (this.$vuetify.breakpoint.name == 'xs') {
        h = 330;
        return h;
      }
      let block = document.querySelector((this.blockName ? `.${this.blockName} ` : '') + n);
      if (block && block.clientHeight) h = block.clientHeight;
      //console.log('getHeightBlock', n, h, block);
      return h;
    },
    autoHeightDetail(v) {
      if (this.$vuetify.breakpoint.name == 'xs') {
        this.detailHeight = 300;
        return;
      }
      let block;

      block = document.querySelector((this.blockName ? `.${this.blockName} ` : '') + '.block_detail');
      if (block) {
        let height = window.innerHeight;
        let c = block.getBoundingClientRect();
        let h = height - c.top - 110;
        //console.log('detailHeight', { height, v, c_top: c.top, h }, block, this.isInDialog);
        this.detailHeight = h < 300 ? 300 : h;
      }
    },
  },
};
